var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sentimiento",attrs:{"id":"sentimiento"}},[_c('div',{staticClass:"corazon"},[_c('a',{on:{"click":function($event){_vm.sendLike(); _vm.trackCorazon();}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/img/corazon.png")}})])]),_c('div',{attrs:{"id":"corazones"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }